export const BASE_CLASS_NAME =
  'flex flex-1 flex-col fixed bg-neutral-000 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-xl shadow-2xl';

export const BACKDROP_CLASS_NAME = 'fixed bg-neutral-900 w-full h-full';
